import DateRangeFilter from "./date_range_filter"
import DayOfWeekFilter from "./day_of_week_filter"
import GenericSelectionFilter from "./generic_selection_filter"
import GenericSpanFilter from "./generic_span_filter"
import MultipleSelectionFilter from "./multiple_selection_filter"
import TimeSpanFilter from "./time_span_filter"
import YesOrNoFilter from "./yes_or_no_filter"

const FILTER_TYPES = {
  date_range: DateRangeFilter,
  day_of_week: DayOfWeekFilter,
  generic_selection: GenericSelectionFilter,
  generic_span: GenericSpanFilter,
  multiple_selection: MultipleSelectionFilter,
  time_span: TimeSpanFilter,
  yes_or_no: YesOrNoFilter,
}

export const createFilter = (definition, context) => {
  const Filter = FILTER_TYPES[definition?.type]
  return Filter ? new Filter(definition, context) : null
}

export default FILTER_TYPES
